module.exports = "/_next/static/images/serverError-d4c36f30c9e5f9c591000512c863dc9f.png";